import { render, staticRenderFns } from "./RecordManager.vue?vue&type=template&id=570ceecc&scoped=true"
import script from "./RecordManager.vue?vue&type=script&lang=js"
export * from "./RecordManager.vue?vue&type=script&lang=js"
import style0 from "./RecordManager.vue?vue&type=style&index=0&id=570ceecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ceecc",
  null
  
)

export default component.exports